<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>
  <div class="editor-registro">
    <div class="divForm">
      <form [formGroup]="editRegistroForm" (onSubmit)="submit()">
        <div class="form-group row">
          <div class="col-sm-12 col-md-12">
            <mat-form-field appearance="outline" class="nombre-motivo-field">
              <mat-label>{{ translation.Nombre }}</mat-label>
              <textarea
                matInput
                formControlName="NombreMotivo"
                class="editor-campo-registro"
                maxlength="250"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="10"
                (input)="onNombreMotivoInput($event)"
              ></textarea>
              <mat-hint 
                align="end"
                [ngClass]="{
                  'mat-hint-warning': getNombreMotivoLength() >= 200 && getNombreMotivoLength() < 250,
                  'mat-hint-error': getNombreMotivoLength() >= 250
                }">
                {{ getNombreMotivoLength() }}/250
              </mat-hint>
              <mat-error *ngIf="validateFields('NombreMotivo')">
                {{ getErrorMessage("NombreMotivo") }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-12 col-md-6">

              <mat-label
                >{{ translation.Seleccionable
                }}<mat-slide-toggle
                  matInput
                  name="Seleccionable"
                  formControlName="Seleccionable"
                ></mat-slide-toggle>
              </mat-label>

          </div>

        </div>

        <div style="margin: 20px 5px 0 5px; text-align: center">
          <!-- -->
          <h2>{{ translation.Idiomas }}</h2>
          <mat-accordion
            *ngFor="let idioma of editorListaIdiomas; let i = index"
          >
            <mat-expansion-panel [expanded]="i == 0">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ idioma.Nombre }}
                </mat-panel-title>
                <mat-panel-description> </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-form-field appearance="outline">
                <mat-label
                  >{{ translation.Nombre }} ({{
                    idioma.CodIdioma
                  }})</mat-label
                >
                <input
                  matInput
                  type="text"
                  placeholder="{{ translation.Nombre }} en {{
                    idioma.Nombre
                  }}"
                  [value]="idioma.Nombre"
                  (change)="
                    cambiaNombre(
                      $any($event.target).value,
                      idioma.CodIdioma
                    )
                  "
                  formControlName="Nombre-{{ idioma.CodIdioma }}"
                />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label
                  >{{ translation.Descripcion }} ({{
                    idioma.CodIdioma
                  }})</mat-label
                >
                <textarea
                  matInput
                  type="text"
                  placeholder="{{ translation.Descripcion }} {{
                    idioma.Nombre
                  }}"
                  [value]="idioma.Descripcion"
                  formControlName="Descripcion-{{ idioma.CodIdioma }}"
                ></textarea>
              </mat-form-field>

              <!-- <mat-form-field appearance="outline">
                <mat-label
                  >{{ translation.URL }} ({{ idioma.CodIdioma }})</mat-label
                >
                <textarea
                  matInput
                  type="text"
                  placeholder="{{ translation.URL }} {{ idioma.Nombre }}"
                  [value]="idioma.URL"
                  formControlName="Url-{{ idioma.CodIdioma }}"
                ></textarea>
              </mat-form-field> -->
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <!-- <div style="margin: 20px 5px 0 5px; text-align: center">
          <mat-label>{{ translation.Idiomas }}</mat-label>

          <customan-dual-list
            [source]="idiomasApp"
            [(destination)]="editorListaIdiomas"
            key="CodIdioma"
            display="Nombre"
            [format]="format"
            [filter]="true"
          >
          </customan-dual-list>
        </div> -->

        <div style="margin: 20px 5px 0 5px; text-align: center">
          <mat-label>{{ translation.Centros }}</mat-label>

          <customan-dual-list
            [source]="centrosSinAsignar"
            [(destination)]="centrosAsignados"
            key="pkId"
            display="Nombre"
            [format]="format"
            [filter]="true"
          >
          </customan-dual-list>
        </div>
      </form>
    </div>
  </div>
</div>
